export default {
      id: "deliveries-menu-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#deliveries-menu-usage",
      toString: function () {
        return this.url;
      }
    }